import eventFrequencyDataset from "../datasets/event_frequency_dataset";

export const editFrequencyAndFreqobj = (frequency, frequencyObj, source) => {
    const freqDatasetObj = eventFrequencyDataset.find(elem => 
        elem.frequency === frequencyObj.frequencyType &&
        elem.tier === frequencyObj.freqPriority
    )
    let errorObj = {};
    if (freqDatasetObj){
        if (frequency !== freqDatasetObj.freqNbr){
            errorObj = {fieldClass:"Header", fieldName: "Frequency", 
                fieldValue: frequency,
                message: "Frequency not consistent with FreqObj"};
        }
    }else{
         errorObj = {fieldClass:"Header", fieldName: "FrequencyObj", 
            fieldValue: frequencyObj,
            message: "FrequencyObj is not valid - not found on frequency dataset"};
    }
    return errorObj;
}
export default editFrequencyAndFreqobj;